import * as moment from "moment";

export const onMoment = (time) => {
    return time;//moment(time).format('MMMM Do YYYY, h:mm a')
  }